module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"fr":{"indicator-general-help":"Aide"},"en":{"indicator-general-help":"Help"}}')
  delete Component.options._Ctor
}
